<template>
  <base-container :isLoading="loading">
    <artisan-group style="margin-bottom: 5px" title="评估信息">
      <el-row
        type="flex"
        class="padding-v7"
        justify="space-around"
        align="middle"
      >
        <div>
          评估状态:
          <el-tag
            v-if="bill.id"
            :type="statusMap[bill.status].type"
            size="small"
          >
            <span :class="payStatusMap[bill.payStatus].type">
              {{ payStatusMap[bill.payStatus].label }}
            </span>
            |
            <span>{{ statusMap[bill.status].label }}</span>
          </el-tag>
        </div>
        <div>
          评估人:
          <b v-html="bill.operator || '-'"></b>
        </div>
        <div>
          评估时间:
          <b v-html="bill.statusTime || '-'"></b>
        </div>
      </el-row>
    </artisan-group>
    <artisan-group title="手术申请单">
      <el-descriptions
        :labelStyle="{ width: '100px' }"
        :column="3"
        size="medium"
        border
      >
        <el-descriptions-item label="申请单号">
          <b>{{ bill.id }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="患者姓名">
          <b>{{ bill.patientName }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="患者性别">
          <b>{{ getGenderLabel(bill.patientGender) }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="出生日期">
          <b>{{ bill.patientBirthday }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="联系电话">
          <b>{{ bill.patientPhone }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="开单医生">
          {{ bill.billDoctorName }}
        </el-descriptions-item>
        <el-descriptions-item label="项目名称">
          {{ bill.projectName }}
        </el-descriptions-item>
        <el-descriptions-item label="就诊号">
          {{ bill.clinicNo }}
        </el-descriptions-item>
        <el-descriptions-item label="就诊类型">
          {{ bill.clinicTypeLabel }}
        </el-descriptions-item>
        <el-descriptions-item label="开单科室">
          {{ bill.billDeptName }}
        </el-descriptions-item>
        <el-descriptions-item label="院区" :span="2">
          {{ bill.hosName }}
        </el-descriptions-item>
        <el-descriptions-item label="项目部位" :span="3">
          <b>{{ bill.partNames }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="3">
          {{ bill.remark }}
        </el-descriptions-item>
      </el-descriptions>
    </artisan-group>
    <el-card style="margin: 5px" shadow="never" v-if="bill.id">
      <div slot="header">
        <span>操作轨迹</span>
      </div>
      <el-timeline :reverse="true">
        <el-timeline-item
          :timestamp="bill.billTime + ' ' + dateWeek(bill.billTime)"
          placement="top"
          type="success"
          icon="el-icon-top"
        >
          <h3>手术申请</h3>
          <div>
            <div>
              <span class="operator" v-html="'[' + bill.appName + ']'"></span
              >&nbsp;
              <span
                v-html="
                  '患者在' +
                  bill.hosName +
                  '申请了' +
                  bill.projectName +
                  '的项目'
                "
              ></span>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item
          v-for="(log, i) in logs"
          :key="i"
          :timestamp="log.nodeTime + ' ' + dateWeek(log.nodeTime)"
          placement="top"
          type="success"
          icon="el-icon-top"
        >
          <h3 v-html="log.nodeName"></h3>
          <div>
            <div>
              <span class="operator" v-html="'[' + log.appName + ']'"></span
              >&nbsp;
              <span v-html="log.content"></span>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </el-card>
  </base-container>
</template>

<script>
import { get } from "@/api/op/record";
import { getGenderLabel } from "@/util/util";
export default {
  props: ["query", "billId"],
  data() {
    return {
      loading: false,
      bill: {},
      logs: [],
      statusMap: {
        wait: {
          label: "待评估",
          type: "info",
        },
        pass: {
          label: "已通过",
          type: "success",
        },
        reject: {
          label: "已驳回",
          type: "danger",
        },
      },
      payStatusMap: {
        paid: {
          label: "已支付",
          type: "color-success",
        },
        unpaid: {
          label: "未支付",
          type: "color-info",
        },
        refund: {
          label: "已退费",
          type: "color-danger",
        },
      },
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    billId() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      const id = this.billId || this.query?.recordId;
      if (id) {
        this.loading = true;
        get({ id })
          .then((res) => {
            let data = res.data.data;
            this.bill = data;
            this.logs = data.logs;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getGenderLabel,
    dateWeek: function (nodeTime) {
      let arr = ["日", "一", "二", "三", "四", "五", "六"];
      let dateObj = new Date(nodeTime);
      let dayOfWeek = dateObj.getDay();
      return "星期" + arr[dayOfWeek];
    }
  },
};
</script>

<style scoped>
.el-descriptions >>> .el-descriptions__header {
  margin-bottom: 10px !important;
  margin-left: 5px !important;
}
.number-code {
  height: 100px;
  min-width: 100px;
  line-height: 100px;
  text-align: center;
  display: inline-block;
  border-radius: 5%;
  background-color: #409eff;
  color: white;
  font-size: 50px;
}
.operator {
  display: inline-block;
  color: #ff3535;
}
.ok {
  color: #1989fa;
}
.cancel {
  color: #e6a23c;
}
.take {
  color: #67c23a;
}
.stop {
  color: #409eff;
}
.undo {
  color: red;
}
</style>
